import { Box, Button, TextField } from "@mui/material";
import { useFormik } from "formik";
import { Fragment, useCallback, useState } from "react";
import { ImPhone } from "react-icons/im";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import BackButton from "../../components/BackButton";
import CountrySelect from "../../components/CountrySelect";
import { sendPasswordRequestService } from "../../services/auth";

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const validationSchema = yup.object({
  mobile: yup
    .string("Enter your mobile")
    .min(5, "too short")
    .max(255, "too long")
    .test("test-name", "Enter Valid Mobile number", function (value) {
      const emailRegex =
        /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      let isValidEmail = emailRegex.test(value);
      let isValidPhone = phoneRegExp.test(value);
      if (!isValidEmail && !isValidPhone) {
        return false;
      }
      return true;
    })
    .required("Enter Valid Mobile number"),
});

export default function SendRequestStep({ onSubmit }) {
  const nav = useNavigate();
  const [loading, setLoading] = useState(false);

  const goBack = () => nav(`/login`);

  const formik = useFormik({
    initialValues: {
      mobile: "",
      countryCode: "20",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const { mobile, countryCode } = values;
      setLoading(true);

      const { error } = await sendPasswordRequestService({
        body: { mobile: countryCode + mobile },
      });
      setLoading(false);
      if (error) {
        formik.setFieldError("mobile", error);
        return console.error(error);
      }
      onSubmit(countryCode + mobile);
    },
  });
  const chooseCountryCode = useCallback(
    (code) => formik.setFieldValue("countryCode", code),
    [formik]
  );

  return (
    <Fragment>
      <BackButton
        primaryText="Forgot"
        secondaryText="password"
        goBack={goBack}
      />
      <Box width={1}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          sx={{ width: "99%", height: 1 }}
        >
          <Box
            sx={{
              width: "100%",
              my: 2,
              backgroundColor: "background.paper",
              borderRadius: "8px",
              alignItems: "center",
            }}
            display="flex"
          >
            <Box
              sx={{
                px: 2,
                borderRight: "2px solid darkgrey",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "text.secondary",
              }}
            >
              <ImPhone size={20} />
            </Box>
            <Box
              sx={{
                width: {
                  xl: "20%",
                  lg: "20%",
                  md: "30%",
                  sm: "30%",
                  xs: "30%",
                },
                mr: 1,
              }}
            >
              <CountrySelect
                disableBorder
                chooseCode={chooseCountryCode}
                error={
                  formik.touched.countryCode &&
                  Boolean(formik.errors.countryCode)
                }
                helperText={
                  formik.touched.countryCode && formik.errors.countryCode
                }
              />
            </Box>
            <TextField
              fullWidth
              id="mobile"
              name="mobile"
              value={formik.values.mobile}
              onChange={formik.handleChange}
              error={formik.touched.mobile && Boolean(formik.errors.mobile)}
              helperText={
                formik.touched.mobile &&
                formik.errors.mobile &&
                formik.errors.mobile
              }
              placeholder="Mobile"
              variant="standard"
              InputProps={{
                disableUnderline: true,
              }}
            />
          </Box>
        </Box>
      </Box>
      <Box width={1}>
        <Button
          fullWidth
          type="submit"
          sx={{ py: 1.5, mt: 16 }}
          variant="contained"
          disabled={loading}
          onClick={formik.handleSubmit}
          color="secondary"
        >
          Send request
        </Button>
      </Box>
    </Fragment>
  );
}
